export const fonts = {
  body: "sans-serif",
};
